import { render, staticRenderFns } from "./RootlineErrorModal.vue?vue&type=template&id=4e906ffd&scoped=true&"
import script from "./RootlineErrorModal.vue?vue&type=script&lang=js&"
export * from "./RootlineErrorModal.vue?vue&type=script&lang=js&"
import style0 from "./RootlineErrorModal.vue?vue&type=style&index=0&id=4e906ffd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e906ffd",
  null
  
)

export default component.exports